// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import volEntity from './entities/vol.json';
import volMenu from '../pages/vol/menu.json';
import volFullForm from '../pages/vol/forms/full.json';
import volContextForm from '../pages/vol/forms/context.json';
import volMiniForm from '../pages/vol/forms/mini.json';
import volLookupForm from '../pages/vol/forms/lookup.json';
import volTableView from '../pages/vol/views/table.json';
import volStagesView from '../pages/vol/views/stages.json';
import volCardsView from '../pages/vol/views/cards.json';
import volInlineView from '../pages/vol/views/inline.json';
import volBacklogView from '../pages/vol/views/backlog.json';
import volSplitView from '../pages/vol/views/split.json';
import volCalendarView from '../pages/vol/views/calendar.json';
import volDashboardView from '../pages/vol/views/dashboard.json';

/** Тип запису «Волонтер» зі сторінками пакета: меню, форми та подання з pages/vol/. */
export const volDefinition: IRecordTypeDefinition = {
  ...volEntity,
  views: assembleViewSet({
      table: volTableView,
      stages: volStagesView,
      cards: volCardsView,
      inline: volInlineView,
      backlog: volBacklogView,
      split: volSplitView,
      calendar: volCalendarView,
      dashboard: volDashboardView,
  }),
  form: volFullForm,
  forms: { full: volFullForm, context: volContextForm, mini: volMiniForm, lookup: volLookupForm },
  menu: volMenu,
} as IRecordTypeDefinition;
